import { buildImageHandlerUrl, parseDocumentObjectUrl, SHARED_DOCUMENTS_BUCKET, type ImageResize } from '@gearbelt/global';

// An unsized request returns the original file, which 413s past the handler's 6 MB response limit.
export const FULL_VIEW_MAX_DIMENSION = 1920;

export function convertFullViewImageUrl(url: string): string {
  return convertImageUrl(url, { width: FULL_VIEW_MAX_DIMENSION, height: FULL_VIEW_MAX_DIMENSION, fitIn: true });
}

/**
 * Turns a stored document image URL into a request to the image handler configured for this build
 * (`VITE_SIH_CF_URL`), resized when asked. Anything that is not a stored document, or a build without a handler,
 * comes back unchanged.
 */
export function convertImageUrl(url: string, options: ImageResize = {}): string {
  if (!url || typeof url !== 'string') {
    return url;
  }
  return buildImageHandlerUrl(import.meta.env.VITE_SIH_CF_URL, url, options);
}

// Logos in the shared bucket keep loading from their stored URL, exactly as before the bucket move; only logos in an
// environment's own bucket, whose stored URL doesn't resolve, go through the handler.
export function convertLogoUrl(url: string): string {
  return parseDocumentObjectUrl(url)?.bucket === SHARED_DOCUMENTS_BUCKET ? url : convertImageUrl(url);
}
